(() => {
  'use strict';

  function setMissingAlt(image, label) {
    if (!image.hasAttribute('alt')) {
      image.setAttribute('alt', label || '');
    }
  }

  function promotionDestinationLabel(link) {
    const current = (link.getAttribute('aria-label') || '').trim();
    if (current && !/^view promotion$/i.test(current)) return current;

    try {
      const url = new URL(link.href, window.location.origin);
      const vendor = url.searchParams.get('q');
      const raw = vendor || url.pathname.split('/').filter(Boolean).pop() || '';
      const words = decodeURIComponent(raw).replace(/[-_]+/g, ' ').replace(/\s+/g, ' ').trim();
      if (words) return `Shop ${words}`;
    } catch (error) {
      return current || 'Homepage promotion';
    }

    return current || 'Homepage promotion';
  }

  function patchAccessibility(root = document) {
    root.querySelectorAll?.('.wishlist-header-link').forEach((link) => {
      if (!link.getAttribute('aria-label')) {
        link.setAttribute('aria-label', (link.textContent || '').trim() || 'Wish lists');
      }
    });

    root.querySelectorAll?.('.site-footer__newsletter-form button[type="submit"]').forEach((button) => {
      if (!button.getAttribute('aria-label')) {
        const label = button.querySelector('span')?.textContent?.trim();
        button.setAttribute('aria-label', label || 'Join newsletter');
      }
    });

    root.querySelectorAll?.('.hero-slide__full-link').forEach((link) => {
      link.setAttribute('aria-label', promotionDestinationLabel(link));
    });

    root.querySelectorAll?.('.hero-slide__media img:not([alt])').forEach((image) => {
      const slide = image.closest('.hero-slide');
      const label = slide?.querySelector('.hero-slide__full-link')?.getAttribute('aria-label')
        || slide?.querySelector('.hero-slide__heading')?.textContent?.trim()
        || 'Homepage promotion';
      setMissingAlt(image, label);
    });

    root.querySelectorAll?.('.campaign-banner__image:not([alt])').forEach((image) => {
      const banner = image.closest('.campaign-banner');
      const label = banner?.getAttribute('aria-label')
        || banner?.querySelector('.campaign-banner__full-link')?.getAttribute('aria-label')
        || banner?.querySelector('h2')?.textContent?.trim()
        || 'Featured promotion';
      setMissingAlt(image, label);
    });

    root.querySelectorAll?.('.brand-story__visual img:not([alt])').forEach((image) => {
      const story = image.closest('.brand-story');
      const label = story?.querySelector('h2')?.textContent?.trim()
        || 'Early Learning Centre play inspiration';
      setMissingAlt(image, label);
    });

    root.querySelectorAll?.('.site-footer__logo img:not([alt])').forEach((image) => {
      const logoLink = image.closest('.site-footer__logo');
      const label = logoLink?.getAttribute('aria-label')?.replace(/\s+home$/i, '').trim()
        || 'Early Learning Centre';
      setMissingAlt(image, label);
    });
  }

  patchAccessibility();

  document.addEventListener('DOMContentLoaded', () => patchAccessibility());
  document.addEventListener('shopify:section:load', (event) => patchAccessibility(event.target));
})();
